<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading">A<span class="smallcaps">LSO AVAILABLE IN THE </span>L<span class="smallcaps">AIDLAW SERIES</span></h1>
<p class="center"><em class="italic">Laidlaw</em></p>
<p class="center"><em class="italic">The Papers of Tony Veitch</em></p>
<p class="center"><em class="italic">Strange Loyalties</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// the-dark-remains_00000.vue?016557a2